import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class GetClaimEligibilityStatusArgs {
  @Field(t => Int)
  arcId!: number

  @Field(t => Boolean)
  suggestArc!: boolean
}
